import CurrencyUtil from '@/core/services/CurrencyUtil';

import {
  formatDateNice,
  formatDateNicer,
  parseDate,
} from '@/core/services/DateUtil';

export const formatDate = (date: string) => formatDateNice(parseDate(date));
export const formatDateWithDay = (date: string) =>
  formatDateNicer(parseDate(date));

export const formatPrice = (value: string) => CurrencyUtil.formatPrice(value);
